import {Component, model, ModelSignal} from '@angular/core';
import {Dialog} from 'primeng/dialog';
import {Button} from 'primeng/button';
import {DialogPosition} from '../../enum/dialog-position.enum';
import {CookieConsentService} from './cookie-consent.service';
import {ConsentLocalStorageService} from '../../local-storage/consent/consent-local-storage.service';
import {CookieConsentModel} from '../../enum/cookie-consent.enum';
import {consentBannerVisibilitySignal} from '../../signal/common/consent-banner-visibility.signal';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-cookie-consent',
  imports: [
    Dialog,
    Button
  ],
  templateUrl: './cookie-consent.component.html',
  styleUrl: './cookie-consent.component.scss'
})
export class CookieConsentComponent {
  position: ModelSignal<DialogPosition> = model<DialogPosition>(DialogPosition.BottomLeft);
  visible: ModelSignal<boolean> = model<boolean>(false);

  protected readonly header: string = "🍪 Używamy ciasteczek";
  protected readonly content: string = "Wykorzystujemy pliki cookie do spersonalizowania treści i reklam, aby oferować funkcje społecznościowe i analizować ruch w naszej witrynie. Informacje o tym, jak korzystasz z naszej witryny, udostępniamy partnerom społecznościowym, reklamowym i analitycznym. Partnerzy mogą połączyć te informacje z innymi danymi otrzymanymi od Ciebie lub uzyskanymi podczas korzystania z ich usług."
  protected readonly privacyPolicyUrl: string = environment.privacyPolicyUrl;
  protected readonly acceptAll: string = "Akceptuj wszystkie"
  protected readonly acceptRequired: string = "Akceptuj wymagane"

  constructor(
    private readonly cookieConsentService: CookieConsentService,
    private readonly consentLocalStorageService: ConsentLocalStorageService
  ) {
  }

  protected onVisibleChange(): void {
    this.visible.set(false);
  }

  protected onAcceptRequiredConsent(): void {
    const consent = CookieConsentModel.Required;
    this.handleConsent(consent);
  }

  protected onAcceptAllConsent(): void {
    const consent = CookieConsentModel.All;
    this.handleConsent(consent);
  }

  private handleConsent(consent: CookieConsentModel): void {
    this.consentLocalStorageService.set(consent);
    this.cookieConsentService.setConsent(consent);
    this.onVisibleChange();
  }

  protected onShow(): void {
    consentBannerVisibilitySignal.set(true);
  }

  protected onHide(): void {
    consentBannerVisibilitySignal.set(false);
  }
}
